import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import Typography from '../Typography';
import TypographyDraft from '../TypographyDraft';

function ScheduleTracks({ classes, tracks, title, styles }) {
  return (
    <div className={classes.root}>
      {title && (
        <TypographyDraft
          component="h3"
          className={classes.title}
          style={{ ...styles.colors.title, ...styles.track }}
          data={title}
        />
      )}
      <ul className={classes.list}>
        {tracks.map((track, i) => (
          <li className={classes.track} key={track.id || i}>
            <span style={{ backgroundColor: track.color }} className={classes.trackIndicator} />
            <Typography
              type="body1"
              component="h4"
              style={{ ...styles.colors.text, ...styles.detail }}
              className={classes.trackTitle}
            >
              {track.title}
            </Typography>
          </li>
        ))}
      </ul>
    </div>
  );
}

ScheduleTracks.propTypes = {
  classes: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  tracks: PropTypes.array.isRequired,
  title: PropTypes.object,
};

ScheduleTracks.defaultProps = {
  title: {},
};

const stylesheet = theme => ({
  '@keyframes fade-in': {
    '0%': {
      opacity: 0,
      transform: `translate(0,-10px)`,
    },
    '100%': {
      opacity: 1,
      transform: `translate(0,0)`,
    },
  },
  root: {
    flex: 1,
    marginTop: theme.spacing.unit,
    marginLeft: 5 * theme.spacing.unit,
    animation: 'fade-in 0.75s ease-out',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: 5 * theme.spacing.unit,
      marginLeft: 0,
    },
  },
  title: {
    marginBottom: 0.5 * theme.spacing.unit,
  },
  list: {
    listStyleType: 'none',
    padding: 0,
  },
  trackIndicator: {
    display: 'inline-block',
    width: 16,
    height: 16,
    borderRadius: '50%',
    margin: [[0, 4]],
  },
  trackTitle: {
    marginBottom: 0.5 * theme.spacing.unit,
    display: 'inline-block',
    margin: {
      bottom: theme.spacing.unit,
      left: theme.spacing.unit,
    },
  },
});

export default injectSheet(stylesheet)(ScheduleTracks);



// WEBPACK FOOTER //
// ./src/site-render/src/ScheduleSection/ScheduleTracks.js